require('angular');
require('angular-animate');
require('angular-ui-router');
require('./anim-in-out');
module.exports = 'anim-in-out';
